import { render, staticRenderFns } from "./ManagementCompany.vue?vue&type=template&id=bb3c18f4"
import script from "./ManagementCompany.vue?vue&type=script&lang=ts"
export * from "./ManagementCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports